import { render, staticRenderFns } from "./QuadroHorarioTurmaPage.vue?vue&type=template&id=216601ea&scoped=true"
import script from "./QuadroHorarioTurmaPage.vue?vue&type=script&lang=js"
export * from "./QuadroHorarioTurmaPage.vue?vue&type=script&lang=js"
import style0 from "./QuadroHorarioTurmaPage.vue?vue&type=style&index=0&id=216601ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216601ea",
  null
  
)

export default component.exports